class MfxBanner extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-banner-slide]')];
    this.index = 0;
    this.timer = null;
    this.paused = false;
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    if (this.slides.length < 2) return;
    this.controls = this.querySelector('[data-banner-controls]');
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.paused = this.motion.matches;
    this.controls.hidden = false;
    this.querySelector('[data-banner-previous]').addEventListener('click', () => this.show(this.index - 1, true), options);
    this.querySelector('[data-banner-next]').addEventListener('click', () => this.show(this.index + 1, true), options);
    this.addEventListener('mouseenter', () => this.stop(), options);
    this.addEventListener('mouseleave', () => this.schedule(), options);
    this.addEventListener('focusin', () => this.stop(), options);
    this.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), options);
    document.addEventListener('visibilitychange', () => this.schedule(), options);
    this.motion.addEventListener('change', () => {
      this.paused = this.motion.matches;
      this.schedule();
    }, options);
    this.schedule();
  }

  show(index, manual = false) {
    this.index = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
    const status = this.querySelector('[data-banner-status]');
    status.setAttribute('aria-live', manual ? 'polite' : 'off');
    status.textContent = `${this.index + 1} / ${this.slides.length}`;
    this.schedule();
  }

  schedule() {
    this.stop();
    if (this.paused || document.hidden || this.matches(':hover') || this.contains(document.activeElement)) return;
    this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.interval) || 6000);
  }

  stop() {
    clearTimeout(this.timer);
    this.timer = null;
  }

  disconnectedCallback() {
    this.stop();
    this.abort?.abort();
  }
}

if (!customElements.get('mfx-banner')) customElements.define('mfx-banner', MfxBanner);
